import dayjs from 'dayjs';
import { each } from 'lodash';
import wNumb from 'wnumb';
import { getYearsRange } from '../react/helpers/dates';

/**
 * Empty function
 *
 * @return void
 */
export function _empty() {}

/**
 * Return data for entity
 *
 * @return object
 */
export function getObjectData(object, id, keys, callback) {
    axios.get(`/api/${object}/${id}/data?keys=${keys}`).then(callback);
}

/**
 * Return options of years
 */
export function getYears(startYear = 2013, endYear = null) {
    const options = {};
    const years = getYearsRange(startYear, endYear);
    each(years, year => (options[year] = year));

    return options;
}

/**
 * Return option
 */
export function getOption(key, value, text) {
    return {
        key: key,
        value: value,
        text: text,
    };
}

/**
 * Format money
 *
 * @return string
 */
export function money(str, decimals) {
    const format = wNumb({
        decimals: decimals !== undefined ? decimals : 2,
        thousand: '.',
        mark: ',',
        prefix: '€ ',
    });

    return format.to(parseFloat(str));
}

/**
 * Format number
 *
 * @return string
 */
export function number(str, decimals = 0, mark = ',', thousand = '.') {
    const format = wNumb({
        decimals,
        thousand,
        mark,
    });

    return format.to(decimals === 0 ? parseInt(str) : parseFloat(str));
}

/**
 * Format number
 *
 * @return void
 */
export function makeNumber(str, mark = ',', thousand = '.') {
    const format = wNumb({
        thousand,
        mark,
    });

    return format.from(str + '');
}

/**
 * Replace route params with actual values
 *
 * @param object route
 * @param object item
 *
 * @return object
 */
export function parseRoute(route, item) {
    let newRoute = route;
    const matches = route.match(/{([^}]+)}/g);

    if (matches.length) {
        matches.map(match => {
            const attribute = match.replace('{', '').replace('}', '');
            newRoute = route.replace(match, item[attribute]);
        });
    }

    return newRoute;
}

/**
 * Save data
 *
 * @return void
 */
export function saveObjectData(object, id, fields, callback) {
    axios.patch(`/api/${object}/${id}/data`, { data: fields }).then(callback);
}

/**
 * Save data
 *
 * @return void
 */
export function removeObjectData(object, id, fields) {
    axios.patch(`/api/${object}/${id}/data/delete`, { data: fields });
}

export const formatBytes = (bytes, decimals = 2) => {
    if (!+bytes) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'Kb', 'Mb', 'Gb'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

export const localDate = date => (date ? dayjs(date).format('L') : '');

export const localDateToMinutes = date =>
    date ? dayjs(date).format('L LT') : '';

export const localDateTime = date =>
    date ? dayjs(date).format('DD/MM/YYYY, HH:mm:ss') : '';

export const apiDate = date => (date ? dayjs(date).format('YYYY-MM-DD') : '');
